export default {"src":"/_next/static/media/affiliate.8ba36f9a.svg","height":494,"width":723,"blurWidth":0,"blurHeight":0};